import { AB_TESTS, AB_TESTS_DATA } from "@trueskin-web/ab-experiments"
import { Icon } from "@trueskin-web/components"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"

import Plan from "./plan"
import TogglePlans from "./toggle-plans"
import usePlanFilters from "./use-plan-filters"
import VisibilityGuard from "./visibility-guard"

const subscriptionServices = [
  "Fortlaufend personalisierte Formel",
  "Chatte während der Behandlung jederzeit mit Deiner Ärztin",
  "Flexibles Lieferdatum, jederzeit kündbar",
]

const SubscriptionService = ({ children }) => (
  <li sx={{ display: "inline-flex", columnGap: 1 }}>
    <Icon icon={checkIcon} color="primary" />
    {children}
  </li>
)

const Subscriptions = ({
  plans,
  selectedPlanId,
  selectedPlan,
  onSelect,
  onToggle,
}) => {
  const { activeFilter, setActiveFilter } = usePlanFilters({ selectedPlan })

  const handleChange = (filter) => {
    setActiveFilter(filter)
    onToggle(filter)
  }

  const filteredPlans = plans.filter(
    (plan) => plan.instalments === activeFilter
  )

  return (
    <div
      sx={{
        p: 4,
        background: "white",
        borderRadius: "8px",
      }}
      data-component-name="PlanSelectionSubscriptionPlans"
    >
      <div
        sx={{
          fontFamily: "NeueHaasGroteskDisplay Pro",
          fontSize: 4,
          lineHeight: 1.4,
        }}
      >
        Auto-Refill
      </div>

      <VisibilityGuard
        testName={AB_TESTS_DATA[AB_TESTS.SinglePurchasePriceIncrease].lsKey}
        showVariants={1}
      >
        <div sx={{ mt: 1 }}>Unser Rundum-sorglos-Paket</div>
        <ul
          sx={{
            my: 4,
            pl: 0,
            listStyle: "none",
            fontSize: 1,
            "&>li:not(:first-child)": {
              mt: 2,
            },
          }}
        >
          {subscriptionServices.map((text, index) => (
            <SubscriptionService key={index}>{text}</SubscriptionService>
          ))}
        </ul>

        <div sx={{ mb: 5, fontSize: 1 }}>
          Du kannst Deine Set-Auswahl jederzeit flexibel anpassen.
        </div>
      </VisibilityGuard>

      <VisibilityGuard
        testName={AB_TESTS_DATA[AB_TESTS.AntiAging].lsKey}
        showVariants={[1, 2]}
      >
        <TogglePlans activeFilter={activeFilter} onClick={handleChange} />
      </VisibilityGuard>
      <div
        sx={{
          display: "grid",
          gap: 4,
        }}
      >
        {filteredPlans.map((plan) => (
          <Plan
            key={plan.id}
            plan={plan}
            selectedPlanId={selectedPlanId}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  )
}

export default Subscriptions
